import React from 'react';
import {NavLink} from 'react-router-dom';
import {Nav, Navbar} from 'react-bootstrap';

export function Navigation(props) {

  return <Navbar bg="indigo" expand="lg">
    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
    <Navbar.Collapse id="basic-navbar-nav">
      <Nav>
        <NavLink className="d-inline p-2 bg-primary text-white"
                 to="/">Inicio</NavLink>
        <NavLink className="d-inline p-2 bg-primary text-white"
                 to="/expedientes">Expedientes</NavLink>
        <div className="d-inline p-2 bg-primary text-white"
             onClick={props.logout}>Salir
        </div>
      </Nav>
    </Navbar.Collapse>
  </Navbar>

}

